import Seo from "../components/Seo";
import Section from "../components/ui-custom/Section";
import CTA from "../components/sections/CTA";
import PageHeader from "../components/ui-custom/PageHeader";
import TiltCard from "../components/ui-custom/TiltCard";
import { Reveal } from "../components/ui-custom/Reveal";
import Icon from "../components/Icon";
import Dashboard from "../components/sections/Dashboard";

const perks = [
  { icon: "Palette", title: "Your Brand & Domain", desc: "Launch the entire platform under your own name, logo and domain." },
  { icon: "LayoutDashboard", title: "Admin & Reseller Panels", desc: "Full control panels to manage retailers, pricing and payouts." },
  { icon: "ShieldCheck", title: "Dedicated Infrastructure", desc: "Isolated, secure and scalable infrastructure for your business." },
  { icon: "Code2", title: "API Integration", desc: "Connect utipanagecy services into your own apps and websites." },
  { icon: "Percent", title: "Custom Commissions", desc: "Set your own margins across every service and tier." },
  { icon: "Headphones", title: "Enterprise Support", desc: "24x7 priority support with a dedicated account manager." },
];

export default function WhiteLabel() {
  return (
    <>
      <Seo title="White Label" description="Launch your own branded fintech platform with utipanagecy White Label — your brand, your domain, every service." />
      <PageHeader eyebrow="White Label" title="Your brand. Our technology." sub="Launch a fully branded digital services platform without writing a single line of code." />
      <Section testId="whitelabel-perks">
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {perks.map((p, i) => (
            <Reveal key={p.title} delay={(i % 3) * 0.08}>
              <TiltCard className="h-full p-6" data-testid={`whitelabel-perk-${i}`}>
                <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-brand-soft text-brand-2">
                  <Icon name={p.icon} size={22} />
                </div>
                <h3 className="mt-5 text-lg font-semibold text-slate-900">{p.title}</h3>
                <p className="mt-2 text-sm text-slate-500">{p.desc}</p>
              </TiltCard>
            </Reveal>
          ))}
        </div>
      </Section>
      <Section eyebrow="Preview" heading="A platform your customers will love" center testId="whitelabel-preview">
        <Dashboard />
      </Section>
      <CTA />
    </>
  );
}
